import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

// Modify the type as per your API response
type SystemSettings = { Detect_Pause: boolean };

export const getSystemSetting = async (): Promise<SystemSettings> => {
  const { data } = await axios.get('/api/system-settings');
  return data as SystemSettings;
};

type QueryFnType = typeof getSystemSetting;

type UseSystemSettingsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useSystemSettings = ({ config }: UseSystemSettingsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['system-settings'],
    queryFn: getSystemSetting,
  });
};

export const updateSystemSetting = async (
  updatedValue: boolean
): Promise<SystemSettings> => {
  const { data } = await axios.post('/api/system-settings', {
    Detect_Pause: updatedValue,
  });
  return data as SystemSettings;
};

export const useUpdateSystemSettings = () => {
  return useMutation(updateSystemSetting);
};
